import { RequireAuth as SharedRequireAuth } from "@vellum/micro-app-auth/router";

import { LoginPage } from "./LoginPage";

export function RequireAuth() {
  return <SharedRequireAuth unauthenticated={() => <LoginPage />} />;
}
